module.exports = __webpack_public_path__ + "static/media/about-header@2x.8d071522.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-header@2x.png
// module id = 582
// module chunks = 23